<template>
  <div class="page-header">
    <PageTitle hideMarginLeft>Настройка пакетов</PageTitle>
    <CustomButton class="create-package-btn" @click="openCreatePresetKitModal">
      <span>Создать пакет</span>
      <q-icon name="add" size="16px" />
    </CustomButton>
  </div>
  <div class="tw-pt-4">
    <TabsWithDrawer
      :tabs="tabs"
      :default-tab="defaultTab"
      drawer-title=""
      :page-title="'Занесение в пакет'"
      :drawer-width="'280px'"
      :show-header="false"
      @tab-changed="onTabChanged"
    >
    </TabsWithDrawer>
  </div>
</template>

<script setup>
import PageTitle from '@/components/common/PageTitle.vue'
import TabsWithDrawer from '@/components/common/TabsWithDrawer.vue'
import CustomButton from '@/components/common/CustomButton.vue'
import { useQuery } from '@tanstack/vue-query'
import { computed, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import PackageContent from './PackageContent.vue'
import { getPresetKitTypes } from './services'
import { MODAL_NAMES } from '@/constants'
import { useAppStore } from '@/services/store/app'

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()

const activeTab = ref(null)
const activePresetKitId = ref(null)

const { data: presetKitTypesData, refetch: refetchPresetKitTypes } = useQuery({
  queryKey: ['presetKitTypes'],
  queryFn: getPresetKitTypes,
  refetchOnWindowFocus: false,
  initialData: { data: [] }
})

const tabs = computed(() => {
  const presetKits = presetKitTypesData.value?.data || []
  return presetKits.map(kit => ({
    key: `preset-kit-${kit.preset_kit_id}`,
    label: kit.preset_kit_name,
    component: PackageContent,
    props: {
      presetKitId: kit.preset_kit_id,
      title: kit.preset_kit_name
    }
  }))
})

const defaultTab = computed(() => {
  if (route.query.presetKitId) {
    const urlPresetKitId = parseInt(route.query.presetKitId)
    const tabKey = `preset-kit-${urlPresetKitId}`
    const tabExists = tabs.value.some(tab => tab.key === tabKey)
    if (tabExists) {
      return tabKey
    }
  }

  const firstTab = tabs.value[0]
  return firstTab ? firstTab.key : null
})

function onTabChanged(tabKey) {
  activeTab.value = tabKey
  const presetKitId = tabKey ? parseInt(tabKey.replace('preset-kit-', '')) : null
  activePresetKitId.value = presetKitId

  const currentTab = route.query.tab || 'main'
  router.push({
    name: 'packageEntry',
    query: {
      presetKitId: presetKitId,
      tab: currentTab
    }
  }).catch(() => {})
}

function openCreatePresetKitModal() {
  appStore.showModal(MODAL_NAMES.AddPresetKit, {
    title: 'Создать пакет',
    onSubmit: async () => {
      await refetchPresetKitTypes()
    }
  })
}
</script>

<style scoped lang="scss">
.page-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 20px;
  
  :deep(.title) {
    margin-bottom: 0;
    flex: 1;
  }
}

.create-package-btn {
  width: auto !important;
  min-width: auto;
  height: 40px !important;
  font-weight: 400;
  padding: 0 16px;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  flex-shrink: 0;
}
</style>

